import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LoaderBlock } from '../../common/components/loaders/LoaderBlock/LoaderBlock'
import { GamesOverview } from '../../composites/GamesOverview/GamesOverview'
import { WelcomeBlock } from '../../composites/WelcomeBlock/WelcomeBlock'
import { useGameData } from '../../contexts/OwnGamesContextProvider'
import { useUser } from '../../contexts/userContext'
import { useGameEditorNavigation } from '../../hooks/useGameEditorNavigation'
import { GamesFilterSettings, TGameCard } from '../../types/commonTypes'
import { getDashboardEmptyContent } from '../../util/game'
import styles from './Dashboard.module.css'
import { SEPPO_GROUPING_BUSINESS } from '../../api/typeConverters'
import { LtiBanner } from '../../composites/WelcomeBlock/components/LtiBanner'
import { LTIOpener } from './LTIOpener'

const DASHBOARD_FILTERS: GamesFilterSettings = {
  age: true,
  language: true,
  subject: true,
  creator: true,
  updatedAtFrom: true,
  updatedAtUntil: true,
  status: true,
}

export const Dashboard: React.FC = () => {
  const { user, updateUser } = useUser()
  const gameData = useGameData()
  const { t } = useTranslation()
  const { goToCreateGame, createGameWithAi } = useGameEditorNavigation()
  const [showLTIOpener, setShowLTIOpener] = useState(false)
  const [activeGame, setActiveGame] = useState<TGameCard>()

  const handleClickCreateGame = async () => {
    await goToCreateGame()
  }

  const handleClickCreateWithAi = async () => {
    createGameWithAi()
  }

  useEffect(() => {
    const refreshView = () => {
      if (document.visibilityState === 'visible') {
        console.log('active again')
        window.self.location.reload()
      }
    }
    if (
      user &&
      user.ltiContext &&
      window.self !== window.parent &&
      user.resultsUrl &&
      user.resultsUrl.indexOf('onedu') > -1
    ) {
      setShowLTIOpener(true)
      //setActiveGame(gameData.pageData?.find((g) => g.ltiContext === user.ltiContext))
      if (gameData.pageData) setActiveGame(gameData.pageData![0])
      document.addEventListener('visibilitychange', refreshView)
    }
    return () => {
      document.removeEventListener('visibilitychange', refreshView)
    }
  }, [gameData.pageData, user])

  return (
    <div className={styles.container}>
      {showLTIOpener && <LTIOpener game={activeGame} user={user} />}
      {user?.ltiContext && <LtiBanner />}
      {user != null && <WelcomeBlock user={user} updateUser={updateUser} />}
      {!gameData.initialFetchDone ? (
        <LoaderBlock />
      ) : (
        <GamesOverview
          title={t('dashboard.my_games_title', 'My games')}
          onClickCreateGame={handleClickCreateGame}
          onClickCreateWithAi={handleClickCreateWithAi}
          showCreateGameCard={!user?.isSponsoredUser && user?.activeBusiness.industry !== SEPPO_GROUPING_BUSINESS}
          gameData={gameData}
          emptyContent={getDashboardEmptyContent(user, t)}
          filterFormSettings={DASHBOARD_FILTERS}
          allowSorting
          ltiContext={user?.ltiContext}
        />
      )}
    </div>
  )
}
